// extracted by mini-css-extract-plugin
export default {"left":"sidebar_left__Pr0pb","right":"sidebar_right__BJRVY"};